import { ClusterIcon } from "assets/icons";

export default [
  {
    id: "clusters",
    title: "Cluster",
    icon: ClusterIcon,
    pageTitle: "Cluster",
    navLink: "/clusters",
    type: "item",
    permissions: ["super_admin", "site_admin", "organization_admin"],
  },
];